module.exports = __webpack_public_path__ + "static/media/fontello.05a69c73.woff";